import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import { useEffect, useRef, useState } from "react";

type TVTextFieldProps = TextFieldProps & {
    name: string;
    typeMask?: string;
}


//Componentes Unform
export const VInput: React.FC<TVTextFieldProps> = ({ name, typeMask = "", ...rest }) => {
    const inputRef = useRef(null);
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue || "");

    useEffect(() => {

        
        registerField({
            name: fieldName,
            ref: inputRef,
            getValue: () => value,
            setValue: (_, newValue) => {                
                setValue(newValue )
            },
        });

    }, [registerField, fieldName, value])

    return (
        <TextField
            ref={inputRef}
            defaultValue={defaultValue}
            {...rest}
             size={"small" }  
            error={!!error}
            helperText={error}            
            onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
            value={value}
            onChange={(e) => { setValue(e.target.value); rest.onChange?.(e); }}          
        />
    );
};